var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPassportLogo64Px = function SvgPassportLogo64Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_3447)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_radial_78_3447)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint1_radial_78_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0ZM30.7623 12.2214C31.6511 11.786 32.5875 11.8158 33.4494 12.3049C36.4377 14.0078 39.417 15.7256 42.3814 17.4613C43.3357 18.022 43.8248 18.9197 43.8278 20.0231C43.8457 23.8911 43.8397 27.7562 43.8278 31.6242C43.8278 31.7674 43.7353 31.9761 43.619 32.0447C42.4708 32.7307 41.3077 33.3897 40.0462 34.1174V33.509C40.0462 29.5307 40.0343 25.5553 40.0552 21.5769C40.0582 20.8134 39.7957 20.3213 39.1187 19.9366C35.6503 17.9653 32.1998 15.9582 28.7433 13.9631C28.5942 13.8766 28.4481 13.7842 28.2214 13.647C29.1102 13.143 29.9094 12.636 30.7564 12.2214H30.7623ZM30.1271 51.7935C29.9333 51.6951 29.7901 51.6265 29.65 51.5459C25.0721 48.9066 20.5003 46.2494 15.9075 43.6309C14.6192 42.8973 14.0317 41.8505 14.0466 40.3802C14.0734 37.2548 14.0645 34.1294 14.0496 31.0009C14.0436 29.5903 14.6162 28.5674 15.8568 27.8636C19.0807 26.0294 22.2867 24.1685 25.4926 22.3046C25.77 22.1435 25.9728 22.1167 26.2621 22.2897C27.3685 22.9547 28.4958 23.5899 29.6738 24.2699C29.4501 24.4041 29.2801 24.5055 29.1072 24.6069C25.6358 26.611 22.1704 28.6211 18.69 30.6132C18.1204 30.9383 17.855 31.3618 17.8609 32.0239C17.8788 34.4872 17.8818 36.9506 17.8609 39.414C17.855 40.0939 18.1264 40.5264 18.7109 40.8604C22.3821 42.9599 26.0384 45.0833 29.7066 47.1888C30.0168 47.3677 30.148 47.5527 30.142 47.9225C30.1152 49.184 30.1331 50.4485 30.1331 51.7965L30.1271 51.7935ZM30.1271 44.7374C29.808 44.5555 29.5784 44.4272 29.3487 44.293C26.438 42.614 23.5303 40.929 20.6136 39.2619C20.2975 39.0829 20.1812 38.8891 20.1842 38.5223C20.205 36.6285 20.1961 34.7348 20.1901 32.841C20.1901 32.5845 20.2289 32.4086 20.4824 32.2654C21.556 31.666 22.6177 31.0397 23.6824 30.4283C23.7599 30.3836 23.8434 30.3508 23.9836 30.2822V32.4086C23.9836 33.5597 24.0015 34.7139 23.9776 35.8651C23.9627 36.5212 24.2162 36.9655 24.7888 37.2876C26.438 38.2181 28.0664 39.1843 29.7156 40.1118C30.0406 40.2938 30.139 40.4966 30.1331 40.8544C30.1122 42.113 30.1241 43.3745 30.1241 44.7344L30.1271 44.7374ZM26.7661 19.88C26.1487 19.5161 25.6209 19.5191 25.0035 19.88C21.5441 21.902 18.0697 23.8971 14.5983 25.9012C14.4522 25.9877 14.3001 26.0652 14.0406 26.2054C14.1331 24.8872 13.8498 23.6436 14.3001 22.4388C14.5446 21.7797 15.0039 21.2846 15.6123 20.9327C18.5081 19.2596 21.4009 17.5836 24.3027 15.9195C25.3614 15.3111 26.441 15.326 27.4997 15.9374C30.7952 17.8341 34.0876 19.7368 37.3741 21.6455C37.5143 21.726 37.6902 21.9079 37.6902 22.0451C37.7141 23.3991 37.7051 24.756 37.7051 26.2084C36.5092 25.5195 35.4058 24.8813 34.3023 24.2431C31.7883 22.7907 29.2682 21.3532 26.7661 19.88ZM49.9236 41.1705C49.8371 42.2352 49.2138 42.9897 48.2923 43.5206C44.7642 45.5485 41.2391 47.5884 37.7141 49.6224C36.6076 50.2606 35.5012 50.8988 34.3918 51.537C34.2576 51.6145 34.1204 51.6801 33.9385 51.7756C33.9266 51.5907 33.9116 51.4565 33.9116 51.3223C33.9116 50.1532 33.9176 48.9871 33.9057 47.8181C33.9057 47.5527 33.9683 47.3916 34.2129 47.2514C39.3543 44.293 44.4928 41.3256 49.6283 38.3612C49.7059 38.3165 49.7924 38.2807 49.9385 38.2121C49.9385 39.25 49.9981 40.2162 49.9236 41.1705ZM49.9504 33.8102C49.9415 35.0211 49.2883 35.871 48.2535 36.4675C44.2334 38.7787 40.2162 41.102 36.1991 43.4222C35.4654 43.8457 34.7288 44.2662 33.9415 44.7195C33.9295 44.5197 33.9146 44.3884 33.9146 44.2542C33.9146 43.1031 33.9266 41.9489 33.9057 40.7978C33.8997 40.4697 34.0101 40.2967 34.2934 40.1327C37.9467 38.0362 41.5881 35.9157 45.2473 33.8311C45.8975 33.4613 46.1838 33.005 46.1778 32.2416C46.151 28.2632 46.1659 24.2848 46.1659 20.3064V19.6116C47.1202 20.1871 48.0149 20.6613 48.8321 21.2399C49.5776 21.7678 49.9534 22.567 49.9564 23.4885C49.9683 26.9301 49.9773 30.3717 49.9534 33.8132L49.9504 33.8102Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0ZM32 2.66667C15.7997 2.66667 2.66667 15.7997 2.66667 32C2.66667 48.2003 15.7997 61.3333 32 61.3333C48.2003 61.3333 61.3333 48.2003 61.3333 32C61.3333 15.7997 48.2003 2.66667 32 2.66667Z",
    fill: "url(#paint2_radial_78_3447)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0ZM32 2.66667C15.7997 2.66667 2.66667 15.7997 2.66667 32C2.66667 48.2003 15.7997 61.3333 32 61.3333C48.2003 61.3333 61.3333 48.2003 61.3333 32C61.3333 15.7997 48.2003 2.66667 32 2.66667Z",
    fill: "url(#paint3_radial_78_3447)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_78_3447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9874 16.91) rotate(44.9817) scale(66.4871 141.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3EEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#A4DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#A6AEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBEE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_78_3447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7755 60.0275) rotate(84.265) scale(34.4374 65.8794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715135,
    stopColor: "#ECBEE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_78_3447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9874 16.91) rotate(44.9817) scale(66.4871 141.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3EEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#A4DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#A6AEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBEE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_78_3447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7755 60.0275) rotate(84.265) scale(34.4374 65.8794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715135,
    stopColor: "#ECBEE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_3447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPassportLogo64Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/passport_logo_64px.db8216401cfe69103a84c011fed8123c.svg";